module.exports = __webpack_public_path__ + "static/media/orders-bg.9a1c84af.png";